import React, { useState } from 'react';
import { BarChart3, Calendar, Plus, ArrowLeft, Activity } from 'lucide-react';
import MRPDashboard from './mrp/MRPDashboard';
import MRPPlansList from './mrp/MRPPlansList';
import MRPPlanDetail from './mrp/MRPPlanDetail';
import MRPItemDetail from './mrp/MRPItemDetail';
import MRPForecast from './mrp/MRPForecast';
import MRPBomView from './mrp/MRPBomView';
import { useNavigation } from '../contexts/NavigationContext';

const MRPView = ({ navigationSource = null }) => {
  // State management
  const [activeView, setActiveView] = useState('dashboard'); // dashboard, plans, plan-detail, item-detail, forecast, bom
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  
  // Navigation context
  const { navigateTo } = useNavigation();
  
  // Handle return to workflows
  const handleReturnToWorkflows = () => {
    navigateTo('workflows');
  };
  
  // Handle view plan details
  const handleViewPlan = (plan) => {
    setSelectedPlan(plan);
    setActiveView('plan-detail');
  };
  
  // Handle view item details
  const handleViewItem = (item) => {
    setSelectedItem(item);
    setActiveView('item-detail');
  };
  
  // Main render based on active view
  const renderContent = () => {
    switch (activeView) {
      case 'dashboard':
        return (
          <MRPDashboard 
            setActiveView={setActiveView} 
            handleViewPlan={handleViewPlan}
            handleViewItem={handleViewItem}
            navigationSource={navigationSource}
            onReturnToWorkflows={handleReturnToWorkflows}
          />
        );
      case 'plans':
        return (
          <MRPPlansList 
            setActiveView={setActiveView} 
            handleViewPlan={handleViewPlan}
            navigationSource={navigationSource}
            onReturnToWorkflows={handleReturnToWorkflows}
          />
        );
      case 'plan-detail':
        return (
          <MRPPlanDetail 
            plan={selectedPlan} 
            setActiveView={setActiveView}
            handleViewItem={handleViewItem}
          />
        );
      case 'item-detail':
        return (
          <MRPItemDetail 
            item={selectedItem} 
            setActiveView={setActiveView} 
          />
        );
      case 'forecast':
        return <MRPForecast setActiveView={setActiveView} />;
      case 'bom':
        return <MRPBomView setActiveView={setActiveView} />;
      default:
        return <MRPDashboard setActiveView={setActiveView} />;
    }
  };

  return (
    <div className="p-6">
      {/* Enhanced Navigation Header */}
      {navigationSource === 'workflows' && (
        <div className="mb-6 bg-blue-50 border border-blue-200 rounded-lg p-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <Activity className="w-5 h-5 text-blue-600" />
              <div>
                <h3 className="text-sm font-medium text-blue-800">
                  來自業務流程: 生產需求規劃與物料計算
                </h3>
                <p className="text-xs text-blue-600">
                  您正在執行生產週期的物料需求計劃步驟
                </p>
              </div>
            </div>
            <button
              onClick={handleReturnToWorkflows}
              className="flex items-center px-3 py-2 text-blue-700 hover:text-blue-800 hover:bg-blue-100 rounded-md transition-colors"
            >
              <ArrowLeft className="w-4 h-4 mr-1" />
              返回業務流程
            </button>
          </div>
        </div>
      )}
      
      {renderContent()}
    </div>
  );
};

export default MRPView;
